//EX 20-09-2026: helper compartido para escapar texto antes de armar una expresion regular.
//
//POR QUE EXISTE (bug reportado por el usuario; el arreglo original quedo en inicio.js, commit b162f4e):
//los buscadores hacian new RegExp(textoDelUsuario, 'i') con el texto CRUDO. Al escribir
//"manzanas varias (" y despues borrar el parentesis, la app moria con:
//  SyntaxError: Invalid regular expression: /manzanas varias (/: Unterminated group
//Lo mismo pasa con "[" (clase sin cerrar) y con "*" (nada que repetir). Como ese new RegExp vive
//dentro de un filtro que corre en un useEffect, la excepcion se lleva puesta la pantalla entera.
//
//QUE HACE: devuelve el texto listo para usarse como parte LITERAL de un patron, escapando los
//metacaracteres de regex (punto, asterisco, mas, interrogacion, circunflejo, $, llaves, parentesis,
//corchetes y barra invertida). Asi buscar "manzanas (15)" encuentra ese texto tal cual (por ejemplo
//"manzanas (15 a 28)") y NO interpreta el parentesis como un grupo:
//  const regexExpB = new RegExp(escaparRegex(arrayBusqueda.expB), 'i');
//
//CUANDO NO USARLO: cuando el metacaracter es INTENCIONAL, es decir cuando el codigo arma el patron a
//proposito. Escapar ahi rompe la busqueda en silencio. Por ejemplo:
//  new RegExp(`^${arrayBusqueda.partidoB}{1,3}`)               // el ^ y el {1,3} son a proposito
//  new RegExp(`(${estadoBusqueda}|${partes.join('|')})`, 'i')  // el grupo y los | son a proposito
//  new RegExp(`${arrayBusqueda.tramitacionADA_B}$`, 'i')       // el $ es a proposito
//
//Acepta cualquier cosa (string, numero, null, undefined). Con null/undefined devuelve "" (patron
//vacio: matchea todo), que es lo esperado; antes new RegExp(null) buscaba la palabra "null" sin
//querer. Si el valor YA es una RegExp armada a proposito (por ejemplo el /./ que varios selects
//usan para "TODOS"), se devuelve su fuente: new RegExp(unaRegex) tambien usa .source, asi que el
//comportamiento no cambia.
const escaparRegex = (valor) => {
	if (valor instanceof RegExp) {
		return valor.source;
	}
	return String(valor ?? '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export { escaparRegex };
export default escaparRegex;
